import { useContext } from 'react'
import { AccountStatementContext } from '../context/AccountStatementContext'
import { getSizedImage } from 'utils/images'
import { useIntl } from 'react-intl'

function LayoutAccountStatement() {
   const { image, loyaltyPlanId, programs, member } = useContext(AccountStatementContext)
   const basePath = process.env.REACT_APP_BASE_PATH
   const bucket = process.env.REACT_APP_BUCKET
   const basePathImg = `${basePath}${bucket}/`
   const intl = useIntl()
   const loyaltyPlanSelected = programs?.find((program) => program.id === Number(loyaltyPlanId))
   const getImage = () => {
      let format = {}
      format = { fit: 'crop', quality: 'low' }
      return getSizedImage(basePathImg + image?.path, format)
   }
   const userData = {
      name: member?.fullName ?? '{user}',
      points: member?.availablePoints ?? 0,
      pointsAccumulated: member?.pointsAccumulated ?? 0,
      pointsRedeemed: member?.pointsRedeemed ?? 0,
      period: member?.monthlyPeriod ?? '{period}',
      loyaltyPlanName: loyaltyPlanSelected?.name ?? '{loyaltyPlanName}',
      urlTerms: loyaltyPlanSelected?.urlTerms,
      benefits: loyaltyPlanSelected?.benefits ?? [
         {
            code: 'EXCLUSIVE_OFFERS',
            name: intl.formatMessage({ id: 'settings.accountStatement.layout.benefits1' }),
         },
         {
            code: 'BEST_PRICE_GUARANTEED',
            name: intl.formatMessage({ id: 'settings.accountStatement.layout.benefits2' }),
         },
         {
            code: 'FLEXIBLE_CANCELLATION_POLICIES',
            name: intl.formatMessage({ id: 'settings.accountStatement.layout.benefits3' }),
         },
      ],
   }
   const logoImage = `${basePathImg}${loyaltyPlanSelected?.image?.path}`
   const transformations = ['e_colorize', 'w_32', 'h_32', 'co_rgb:8d713a']
   const iconPath = `${basePath}/${transformations.join(',')}/assets/icons/${'benefits'}/`
   return (
      <div className="max-w-xl mx-auto bg-white shadow-md p-6 rounded-md border w-3/4">
         {/* Logo */}
         <div className="text-center mb-[55px]">
            <img src={logoImage} alt="Brisas Rewards" className="mx-auto h-[91px]" />
         </div>
         {/* Saludo */}
         <p className="text-gray-700 mb-4">
            {intl.formatMessage(
               { id: 'settings.accountStatement.layout.greetings' },
               { name: <span className="font-semibold">{userData.name}</span> },
            )}
         </p>
         {/* Descripción */}
         <p className="text-gray-600  mb-6">
            {intl.formatMessage(
               { id: 'settings.accountStatement.layout.welcome' },
               {
                  name: userData.loyaltyPlanName,
                  period: <span className="font-semibold">{userData.period}</span>,
               },
            )}
         </p>
         {/* Tabla de puntos */}
         <table className="border w-full ">
            <tbody>
               <tr className="flex justify-between p-2 ">
                  <td>{intl.formatMessage({ id: 'settings.accountStatement.layout.pointsAcumulated' })}</td>
                  <td className="font-semibold">{userData.pointsAccumulated}</td>
               </tr>
               <tr className="flex justify-between p-2 border-t border-b">
                  <td>{intl.formatMessage({ id: 'settings.accountStatement.layout.pointsRedeemed' })}</td>
                  <td className="font-semibold">{userData.pointsRedeemed}</td>
               </tr>
               <tr className="flex justify-between  p-2 font-semibold ">
                  <td>{intl.formatMessage({ id: 'settings.accountStatement.layout.totalPoints' })}</td>
                  <td>{userData.points}</td>
               </tr>
            </tbody>
         </table>
         {/* Espacio vacío */}
         <div className="mt-6 border overflow-hidden  border-blue-300  min-h-[100px]  flex items-center justify-center">
            {image && <img src={getImage()} alt="" className="object-contain w-full h-full" />}
         </div>
         <div className="border my-[30px]"></div>

         {/* Beneficios */}
         <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-4">
            {intl.formatMessage({ id: 'settings.accountStatement.layout.menssage' })}
         </h3>
         <ul className="text-gray-700 space-y-3">
            {userData.benefits?.map((benefit: any, index: number) => (
               <li key={benefit?.id || index} className={'flex items-center gap-y-2 gap-x-2 py-4 '}>
                  <div style={{ height: '2rem', width: '2rem', color: '#4B5563' }}>
                     <img src={iconPath + benefit.code + '.png'} alt={benefit.code} />
                  </div>
                  <div>{benefit.name}</div>
               </li>
            ))}
         </ul>
         {/* Botones */}
         <div className="flex gap-4 mt-6">
            <button className="bg-gray-900 text-white py-2 px-4 rounded-md w-full">
               {intl.formatMessage({ id: 'settings.accountStatement.layout.button1' })}
            </button>
            <button className="border border-gray-400 text-gray-900 py-2 px-4 rounded-md w-full">
               {intl.formatMessage({ id: 'settings.accountStatement.layout.button2' })}
            </button>
         </div>
         {/* Despedida */}
         <p className="text-gray-600  mt-6">
            {intl.formatMessage({ id: 'settings.accountStatement.layout.farewell' })}
         </p>
         <p className="text-gray-600  mt-6 mb-[54px]">{loyaltyPlanSelected?.name}</p>
         <div className="border mt-4"></div>
         {/* Términos y condiciones */}
         <div className="mt-6 text-gray-500 text-sm">
            <p>
               {intl.formatMessage(
                  { id: 'settings.accountStatement.layout.terms' },
                  {
                     link: (
                        <a
                           href={userData?.urlTerms}
                           className="text-blue-500 block underline"
                           target="_blank"
                           rel="noopener noreferrer"
                        >
                           {userData.urlTerms}
                        </a>
                     ),
                  },
               )}
            </p>
            <p className="mt-2">
               {intl.formatMessage(
                  { id: 'settings.accountStatement.layout.terms&conditions' },
                  {
                     name: loyaltyPlanSelected?.name,
                  },
               )}
            </p>
         </div>
      </div>
   )
}

export default LayoutAccountStatement
